import { create } from 'zustand'
import { SuggestionOriginEnum } from '../interfaces/autocomplete'

interface State {
  sessionToken: string | undefined
  totalSuggestionsZones: string[]
  totalSuggestionsGoogle: string[]
  selectedSuggestionOrigin: SuggestionOriginEnum | undefined
  product: string | undefined
}

interface Setters {
  setSessionToken: (value: string | undefined) => void
  setTotalSuggestionsZones: (value: string[]) => void
  setTotalSuggestionsGoogle: (value: string[]) => void
  setSelectedSuggestionOrigin: (value: SuggestionOriginEnum | undefined) => void
  setProduct: (value: string) => void
}

const initialState: State = {
  sessionToken: undefined,
  totalSuggestionsZones: [],
  totalSuggestionsGoogle: [],
  selectedSuggestionOrigin: undefined,
  product: undefined
}

export const useAutocompleteStore = create<State & Setters>((set) => ({
  ...initialState,
  setSessionToken: (value) =>
    set(() => ({
      sessionToken: value
    })),
  setTotalSuggestionsZones: (value) =>
    set(() => ({
      totalSuggestionsZones: value
    })),
  setTotalSuggestionsGoogle: (value) =>
    set(() => ({
      totalSuggestionsGoogle: value
    })),
  setSelectedSuggestionOrigin: (value) =>
    set(() => ({
      selectedSuggestionOrigin: value
    })),
  setProduct: (value) =>
    set(() => ({
      product: value
    }))
}))
